var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import classNames from 'clsx';
import * as React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../icon';
import Input from '../input';
import { Styled } from './style';
var InlineInput = /** @class */ (function (_super) {
    __extends(InlineInput, _super);
    function InlineInput(props) {
        var _this = _super.call(this, props) || this;
        _this.focusAtLastChar = function (event) {
            event.stopPropagation();
            var value = event.currentTarget.value;
            event.currentTarget.value = '';
            event.currentTarget.value = value;
        };
        _this.enableEditMode = function (e) {
            e.stopPropagation();
            var _a = _this.props, onClickFocusInput = _a.onClickFocusInput, disabled = _a.disabled, onEdit = _a.onEdit;
            onClickFocusInput && onClickFocusInput(true);
            if (!disabled) {
                _this.setState({ editmode: true });
                onEdit && onEdit();
            }
        };
        _this.disableEditMode = function () {
            _this.setState({ editmode: false });
            _this.props.onClickFocusInput && _this.props.onClickFocusInput(false);
        };
        _this.saveValue = function (event, newValue) {
            event.stopPropagation();
            var _a = _this.props, value = _a.value, onSaved = _a.onSaved, onClickFocusInput = _a.onClickFocusInput;
            var name = (newValue || value || '').trim();
            _this.setState({ name: name });
            onSaved && onSaved(event, name);
            onClickFocusInput && onClickFocusInput(false);
        };
        _this.handlerKeyDown = function (event) {
            event.stopPropagation();
            var key = event.key, value = event.currentTarget.value;
            var next = _this.props.next;
            if (key === 'Enter') {
                _this.saveValue(event, value);
                _this.disableEditMode();
                next && next();
            }
            else if (key === 'Escape') {
                _this.saveValue(event, '');
                _this.disableEditMode();
            }
        };
        _this.renderTextInput = function () {
            var name = _this.state.name;
            var _a = _this.props, placeholder = _a.placeholder, onClickFocusInput = _a.onClickFocusInput, maxLength = _a.maxLength;
            return React.createElement(Input, { autoFocus: true, value: name, maxLength: maxLength, fluid: true, placeholder: placeholder, onChange: function (event) {
                    event.stopPropagation();
                    _this.setState({ name: event.target.value });
                }, onFocus: _this.focusAtLastChar, onKeyDown: _this.handlerKeyDown, onBlur: function (event) {
                    event.stopPropagation();
                    _this.saveValue(event, event.currentTarget.value || placeholder);
                    onClickFocusInput && onClickFocusInput(false);
                    _this.disableEditMode();
                }, onClick: function (e) { return e.stopPropagation(); }, spellCheck: _this.props.spellCheck || false });
        };
        _this.renderTextLabel = function () {
            var name = _this.state.name;
            var _a = _this.props, placeholder = _a.placeholder, disabled = _a.disabled, url = _a.url, showIcon = _a.showIcon, maxLength = _a.maxLength;
            var textLabel = (React.createElement(React.Fragment, null,
                React.createElement(Input, { maxLength: maxLength, disabled: true, className: "truncate", value: name }),
                ' '));
            if (!disabled) {
                if (url) {
                    textLabel = (React.createElement(React.Fragment, null,
                        React.createElement(Link, { to: url }, name),
                        " ",
                        React.createElement(Icon, { onClick: _this.enableEditMode, name: "edit", title: "Rename" })));
                }
                else if (showIcon) {
                    textLabel = (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "truncate", onClick: _this.enableEditMode }, name),
                        ' ',
                        React.createElement(Icon, { onClick: _this.enableEditMode, name: "edit", title: "Rename" })));
                }
                else {
                    textLabel = React.createElement(Input, { maxLength: maxLength, onClick: _this.enableEditMode, placeholder: placeholder, className: "truncate", value: name, onChange: function (event) {
                            _this.saveValue(event, event.currentTarget.value);
                        }, spellCheck: _this.props.spellCheck || false });
                }
            }
            return textLabel;
        };
        _this.state = {
            editmode: _this.props.editmode,
            name: _this.props.value,
        };
        return _this;
    }
    InlineInput.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.value !== prevProps.value && this.props.value !== prevState.name) {
            this.setState({ name: this.props.value });
        }
    };
    InlineInput.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, showIcon = _a.showIcon;
        var editmode = this.state.editmode;
        return (React.createElement(Styled, { "data-testid": this.props['data-testid'] || 'inline-input', className: classNames('inline-input', { disabled: disabled, 'with-icon': showIcon }) }, editmode ? this.renderTextInput() : this.renderTextLabel()));
    };
    InlineInput.defaultProps = {
        value: '',
        placeholder: '',
        editmode: false,
        disabled: false,
    };
    return InlineInput;
}(React.Component));
export { InlineInput };
export default InlineInput;
//# sourceMappingURL=index.js.map